import { atom } from 'nanostores';

// A pending prompt to inject into the chat as if the user typed it. The
// IntegrationsPanel sets it when a tile's "Add" (or a Manage step) needs the
// agent to write code; Chat.client.tsx submits it through the normal send path
// and then clears it. This is the same mechanism as $styleSaveRequest.
export const $integrationRequest = atom<string | null>(null);
